import { render } from "./EmailTemplateIndex.vue?vue&type=template&id=5d7e4ef8"
import script from "./EmailTemplateIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTemplateIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Email/EmailTemplateIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d7e4ef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d7e4ef8', __exports__)) {
    api.reload('5d7e4ef8', __exports__)
  }
  
  module.hot.accept("./EmailTemplateIndex.vue?vue&type=template&id=5d7e4ef8", () => {
    api.rerender('5d7e4ef8', render)
  })

}


export default __exports__